const defaults = {
    contactEmail: 'michelle@sensiblesurveys.com',
    contactPhone: '(404) 492-8296',
    countryCode: '+1',
};

export default defaults;
